import React, { Component } from 'react';
import styles from './BatchUpload.module.css';
import { connect } from 'react-redux';
import { createJob } from '../../modules/jobs';
import FileUpload from '../../components/FileUpload';

class BatchUpload extends Component {
  state = {
    models: null,
    materials: null,
    scenes: null,
  };

  navTo = (id, cat) => {
    const { router } = this.context;
    const url = `/${cat}${id ? `/${id}` : ''}`;
    router.history.push(url);
  };

  handleAddFile = (file, type) => {
    this.setState({ [type]: file });
  };

  startBatchUpload = async type => {
    const file = this.state[type];
    const { createJob } = this.props;
    const jobAttr = {
      type: 'batch-upload',
      catogary: type,
    };
    this.setState({ loading: true });
    await createJob(jobAttr, file);
    this.setState({ loading: false });
  };

  render() {
    const { loading } = this.state;
    return (
      <div className={styles.container}>
        <div className={styles.header}>Batch Upload</div>
        <div className={styles.description}>
          To initiate a new project, upload the project spreadsheet and make
          sure
        </div>
        <FileUpload
          header="Models "
          filenote="zip format only"
          navTo={this.navTo}
          onFileUpload={file => this.handleAddFile(file, 'models')}
          onUpload={e => this.startBatchUpload('models')}
        />
        {loading && <img src={'/img/loading.svg'} />}
        <FileUpload
          header="Materials"
          navTo={this.navTo}
          onFileUpload={file => this.handleAddFile(file, 'materials')}
          onUpload={e => this.startBatchUpload('materials')}
        />
        <FileUpload
          header="Scenes"
          navTo={this.navTo}
          onFileUpload={file => this.handleAddFile(file, 'scenes')}
          onUpload={e => this.startBatchUpload('scenes')}
        />
      </div>
    );
  }
}

const stateToProps = state => ({});

export default connect(
  stateToProps,
  { createJob }
)(BatchUpload);



// WEBPACK FOOTER //
// ./src/containers/BatchUpload/index.js